import OnHold from '@/components/auth/on-hold';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

export default function LoginPage() {
  return <OnHold />;
}
